/**
 * This class specifies column width and minWidth properties used for each of the Data Grid Column
 * usage:
 *      1. import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
 *
 *      2. assign values for width and minWidth props under column definition
 *         ColumnWidth.TaxFXLineTotal.width
 *         ColumnWidth.TaxFXLineTotal.minWidth
 */
export default class ColumnWidth {
  static Price4DecimalPoints = new ColumnWidth(125, 125);
  static Price2DecimalPoints = new ColumnWidth(105, 105);
  static PriceWithSign = new ColumnWidth(150, 150);
  static Percentage = new ColumnWidth(115, 115);
  static Quantity = new ColumnWidth(105, 105);
  static Quantity2DecimalPoints = new ColumnWidth(105, 105);
  static Quantity4DecimalPoints = new ColumnWidth(125, 125);
  static Date = new ColumnWidth(100, 100);
  static DateTime = new ColumnWidth(190, 190);
  static Time = new ColumnWidth(90, 90);
  static Duration = new ColumnWidth(90, 90);
  static DateCreated = new ColumnWidth(100, 100);
  static Name = new ColumnWidth(100, 100);
  static CurrencyCode = new ColumnWidth(70, 70);

  static UnitOfMeasure = new ColumnWidth(70, 70);
  static ProductionUnitOfMeasure = new ColumnWidth(110, 110);
  static TaxCode = new ColumnWidth(50, 50);
  static CompanyName = new ColumnWidth(150, 150);
  static Compliance = new ColumnWidth(150, 150);
  static BranchCode = new ColumnWidth(85, 85);
  static Branch = new ColumnWidth(120, 120);
  static Division = new ColumnWidth(85, 85);
  static RepCode = new ColumnWidth(85, 85);
  static ProductOrAccount = new ColumnWidth("auto", 420);
  static Comment = new ColumnWidth(350, 350);
  static DeliveryNumber = new ColumnWidth(70, 70);
  static ItemType = new ColumnWidth(70, 70);
  static InvoiceNumber = new ColumnWidth(70, 70);
  static InvoiceRef = new ColumnWidth(90, 90);
  static SalesOrderNumber = new ColumnWidth(90, 90);
  static PurchaseOrderCode = new ColumnWidth(125, 125);
  static PurchaseOrderWrap = new ColumnWidth(80, 80);
  static GoodsInCode = new ColumnWidth(90, 90);
  static AccountCode = new ColumnWidth(100, 100);
  static ProductDescription = new ColumnWidth(250, 250);
  static ProductCode = new ColumnWidth(150, 150);
  static Description = new ColumnWidth("auto", 250);
  static TransactionPartner = new ColumnWidth(300, 250);

  static TaxableFXLineTotal = new ColumnWidth(150, 150);
  static TotalAmount = new ColumnWidth(130, 130);
  static TaxFXLineTotal = new ColumnWidth(100, 100);
  static BankAccount = new ColumnWidth(150, 150);

  static BankAccountAmount = new ColumnWidth(150, 150);

  static LineNo = new ColumnWidth(80, 80);
  static Code = new ColumnWidth(100, 100);
  static ItemCount = new ColumnWidth(100, 100);
  static CustPO = new ColumnWidth(140, 140);
  static Brand = new ColumnWidth(140, 140);
  static OrderPriority = new ColumnWidth(140, 140);
  static Carrier = new ColumnWidth(140, 140);

  // static ExchangeRate = new ColumnWidth(100, 100);
  static PaymentType = new ColumnWidth(120, 120);
  static PaymentReference = new ColumnWidth(120, 120);

  static Amount = new ColumnWidth(120, 120);
  static TransactionType = new ColumnWidth(120, 120);

  static TransactionNo = new ColumnWidth(105, 105);
  static Username = new ColumnWidth(120, 120);
  static ExchangeRate = new ColumnWidth(110, 110);

  static TransactionMethod = new ColumnWidth(150, 150);

  static OrderRep = new ColumnWidth(150, 150);
  static TransactionAccount = new ColumnWidth(200, 200);

  static Market = new ColumnWidth(100, 100);
  static GridCellCheckBox = new ColumnWidth(100, 100);
  static CheckBoxColumn = new ColumnWidth(50, 50);

  static Discount = new ColumnWidth(70, 70);

  static SalesOrderCode = new ColumnWidth(110, 110);
  static Contract = new ColumnWidth(150, 150);
  static PSlipStatus = new ColumnWidth(50, 50);
  static POSRefundStatus = new ColumnWidth(125, 125);

  static MobileNumber = new ColumnWidth(100, 100);
  static Email = new ColumnWidth(150, 150);
  static PaymentRun = new ColumnWidth(120, 120);

  static CustomerType = new ColumnWidth(130, 130);
  static Region = new ColumnWidth(105, 105);
  static State = new ColumnWidth(105, 105);
  static Country = new ColumnWidth(105, 105);

  static ActionColumn = new ColumnWidth(50, 50);
  static InvoiceType = new ColumnWidth(100, 100);

  static CustomerContact = new ColumnWidth(150, 150);
  static SampleRequest = new ColumnWidth(100, 100);
  static SupplierRef = new ColumnWidth(180, 180);
  static LineInfo = new ColumnWidth(80, 80);
  static BatchNo = new ColumnWidth(160, 160);
  static SupplierBatchNo = new ColumnWidth(160, 160);
  static WorkOrder = new ColumnWidth(100, 100);
  static SupplierCode = new ColumnWidth(120, 120);

  static ColumnValue = new ColumnWidth(150, 150);

  constructor(width, minWidth) {
    this.width = width;
    this.minWidth = minWidth;
  }

  toString() {
    return `${this.width}`;
  }

  static getValue(attributeName) {
    const attribute = this[attributeName];
    if (attribute instanceof ColumnWidth) {
      return attribute;
    } else {
      return null;
    }
  }
}
